<div 
  [ngClass]="getStyleClass()"
  class="rem-bg-light rem-text-default border-round-md py-1 px-2 cursor-pointer" 
     >
  <i [ngClass]="'text-xs pi pi-'+icon"></i>
  <span *ngIf="label" class="ml-2 text-xs">{{label}}</span>
</div>
